<template>
  <div class="app-container">
    <CrudTable entity="ReasonStockCorrection" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'description',
        {
          field: 'reasonStockCorrectionOption',
          label: 'reasonStockCorrection.reasonStockCorrectionOption',
          formatter: this.formatReasonStockCorrectionOption,
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  methods: {
    formatReasonStockCorrectionOption(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('reasonStockCorrection').find(item => item.code === cellValue);
      return option && option.description;
    },
    generateSummary({ description }) {
      const summary = `${description}`;
      return summary;
    }
  }
};
</script>
